export const adTypeMap: Record<string, string> = {
  "1": "Image",
  "2": "Native",
  "3": "Video",
  "4": "Template",
  all: "All Types",
};

export default { adTypeMap };
